/**
 * Created by shuchengliang on 2016/12/28.
 */
// var videojs = require('video.js');
// var $ = require('jquery');
require('../../scss/utils/swiper/swiper.min.css');
require('../../scss/m/m-index.scss');

require('../../img/mobile/m-index-img1.jpg');
require('../../img/mobile/m-index-img2.jpg');
require('../../img/mobile/m-index-img3.jpg');
require('../../img/mobile/m-index-img4.jpg');
require('../../img/mobile/m-index-img5.jpg');
require('../../img/mobile/m-index-img6.jpg');
require('../../img/mobile/m-index-img7.jpg');
require('../../img/mobile/m-index-img8.jpg');
require('../../img/mobile/m-index-img9.png');

require('./m-common');
// var wx = require('./weixin');

// var video = $('#video')[0];

// document.querySelector('.video').addEventListener('click', () => {
//     if (video.paused) {
//         video.play();
//         $('.btn-play').hide();
//         $('.video img').hide();
//     } else {
//         video.pause();
//         $('.btn-play').show();
//         $('.video img').show();
//     }
// });
var $ = require('jquery');

var mySwiper = new Swiper('.swiper', {
    // direction: 'vertical', // 垂直切换选项
    loop: true, // 循环模式选项
    // 如果需要分页器
    pagination: {
      el: '.swiper-pagination',
      bulletClass : 'my-bullet',
      bulletActiveClass: 'my-bullet-active',
    },
  })      
// $(function(){
//     var mySwiper = new Swiper('.swiper', {
//         // direction: 'vertical', // 垂直切换选项
//         loop: true, // 循环模式选项
//         // 如果需要分页器
//         pagination: {
//           el: '.swiper-pagination',
//         },
//       })       
// })

// $(function(){
//     var my_timestamp, my_nonceStr, my_signature;
//     var cururl = location.href.split('#')[0];
//     var domain = window.location.origin;

//     $.ajax({
//         url:'http://slide.cm/wechat/config',
//         type:'GET',
//         data:{
//             url: cururl
//         },
//         dataType:'json',
//         success:function(data){
//             my_nonceStr = data.config.nonceStr;
//             my_timestamp = data.config.timestamp;
//             my_signature = data.config.signature;
//             wconfig(my_timestamp, my_nonceStr, my_signature);
//         }
//     });

//     function wconfig(my_timestamp, my_nonceStr, my_signature){
//         wx.config({
//             debug: false,
//             appId: 'wx82a5d90838b461ba',
//             timestamp: my_timestamp,
//             nonceStr: my_nonceStr,
//             signature: my_signature,
//             jsApiList: [
//                 'checkJsApi',
//                 'onMenuShareTimeline',
//                 'onMenuShareAppMessage',
//                 'onMenuShareQQ',
//                 'onMenuShareWeibo',
//                 'hideMenuItems',
//                 'showMenuItems',
//                 'hideAllNonBaseMenuItem',
//                 'showAllNonBaseMenuItem',
//                 'translateVoice',
//                 'startRecord',
//                 'stopRecord',
//                 'onRecordEnd',
//                 'playVoice',
//                 'pauseVoice',
//                 'stopVoice',
//                 'uploadVoice',
//                 'downloadVoice',
//                 'chooseImage',
//                 'previewImage',
//                 'uploadImage',
//                 'downloadImage',
//                 'getNetworkType',
//                 'openLocation',
//                 'getLocation',
//                 'hideOptionMenu',
//                 'showOptionMenu',
//                 'closeWindow',
//                 'scanQRCode',
//                 'chooseWXPay',
//                 'openProductSpecificView',
//                 'addCard',
//                 'chooseCard',
//                 'openCard'
//             ]
//         });

//         wx.ready(function(){
//             wx.onMenuShareTimeline({
//                 title: '华兴资本-中国领先的服务新经济的金融机构', // 分享标题
//                 link: 'https://www.huaxing.com/m/', // 分享链接
//                 imgUrl: domain + '/images/jsshare.jpg', // 分享图标
//                 success: function () {
//                   // 用户确认分享后执行的回调函数
//                 },
//                 cancel: function () {
//                   // 用户取消分享后执行的回调函数
//                 }
//             });
//             wx.onMenuShareAppMessage({
//                 title: '华兴资本', // 分享标题
//                 desc: '华兴资本-中国领先的服务新经济的金融机构', // 分享描述
//                 link: 'https://www.huaxing.com/m/', // 分享链接
//                 imgUrl: '', // 分享图标
//                 type: '', // 分享类型,music、video或link，不填默认为link
//                 dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
//                 success: function (){
//                     // 用户确认分享后执行的回调函数
//                 },
//                 cancel: function () {
//                     // 用户取消分享后执行的回调函数
//                 }
//             });
//         });
//     }
// })




// WEBPACK FOOTER //
// ./src/m/m-index.js